import React from 'react';
import './Home.css';
import { Link } from "react-router-dom";

function Home() {

  function MSE193() {
    var year = new Date()
    var link1 = "https://www.sfu.ca/students/calendar/"
    var link2 = "/summer/courses/mse/193.html";
    return (link1 + year.getFullYear() + link2)
  }

  function MSE293() {
    var year = new Date()
    var link1 = "https://www.sfu.ca/students/calendar/"
    var link2 = "/summer/courses/mse/293.html";
    return (link1 + year.getFullYear() + link2)
  }

  function MSE393() {
    var year = new Date()
    var link1 = "https://www.sfu.ca/students/calendar/"
    var link2 = "/summer/courses/mse/393.html";
    return (link1 + year.getFullYear() + link2)
  }

  function MSE493() {
    var year = new Date()
    var link1 = "https://www.sfu.ca/students/calendar/"
    var link2 = "/summer/courses/mse/493.html";
    return (link1 + year.getFullYear() + link2)
  }

  return (
    <div className = "grid-container">
      
      {/* Programmed by:
                                                                                                                                                                                                                                                                       
                                                                                                                                                                                                                                                                
  DDDDDDDDDDDDD                                                       tttt                                                       BBBBBBBBBBBBBBBBB     iiii                                                                     tttt                            
  D::::::::::::DDD                                                 ttt:::t                                                       B::::::::::::::::B   i::::i                                                                 ttt:::t                            
  D:::::::::::::::DD                                               t:::::t                                                       B::::::BBBBBB:::::B   iiii                                                                  t:::::t                            
  DDD:::::DDDDD:::::D                                              t:::::t                                                       BB:::::B     B:::::B                                                                        t:::::t                            
    D:::::D    D:::::D     eeeeeeeeeeee  xxxxxxx      xxxxxxxttttttt:::::ttttttt        eeeeeeeeeeee    rrrrr   rrrrrrrrr          B::::B     B:::::Biiiiiii    ggggggggg   ggggguuuuuu    uuuuuu      eeeeeeeeeeee    ttttttt:::::ttttttt      aaaaaaaaaaaaa   
    D:::::D     D:::::D  ee::::::::::::ee x:::::x    x:::::x t:::::::::::::::::t      ee::::::::::::ee  r::::rrr:::::::::r         B::::B     B:::::Bi:::::i   g:::::::::ggg::::gu::::u    u::::u    ee::::::::::::ee  t:::::::::::::::::t      a::::::::::::a  
    D:::::D     D:::::D e::::::eeeee:::::eex:::::x  x:::::x  t:::::::::::::::::t     e::::::eeeee:::::eer:::::::::::::::::r        B::::BBBBBB:::::B  i::::i  g:::::::::::::::::gu::::u    u::::u   e::::::eeeee:::::eet:::::::::::::::::t      aaaaaaaaa:::::a 
    D:::::D     D:::::De::::::e     e:::::e x:::::xx:::::x   tttttt:::::::tttttt    e::::::e     e:::::err::::::rrrrr::::::r       B:::::::::::::BB   i::::i g::::::ggggg::::::ggu::::u    u::::u  e::::::e     e:::::etttttt:::::::tttttt               a::::a 
    D:::::D     D:::::De:::::::eeeee::::::e  x::::::::::x          t:::::t          e:::::::eeeee::::::e r:::::r     r:::::r       B::::BBBBBB:::::B  i::::i g:::::g     g:::::g u::::u    u::::u  e:::::::eeeee::::::e      t:::::t              aaaaaaa:::::a 
    D:::::D     D:::::De:::::::::::::::::e    x::::::::x           t:::::t          e:::::::::::::::::e  r:::::r     rrrrrrr       B::::B     B:::::B i::::i g:::::g     g:::::g u::::u    u::::u  e:::::::::::::::::e       t:::::t            aa::::::::::::a 
    D:::::D     D:::::De::::::eeeeeeeeeee     x::::::::x           t:::::t          e::::::eeeeeeeeeee   r:::::r                   B::::B     B:::::B i::::i g:::::g     g:::::g u::::u    u::::u  e::::::eeeeeeeeeee        t:::::t           a::::aaaa::::::a 
    D:::::D    D:::::D e:::::::e             x::::::::::x          t:::::t    tttttte:::::::e            r:::::r                   B::::B     B:::::B i::::i g::::::g    g:::::g u:::::uuuu:::::u  e:::::::e                 t:::::t    tttttta::::a    a:::::a 
  DDD:::::DDDDD:::::D  e::::::::e           x:::::xx:::::x         t::::::tttt:::::te::::::::e           r:::::r                 BB:::::BBBBBB::::::Bi::::::ig:::::::ggggg:::::g u:::::::::::::::uue::::::::e                t::::::tttt:::::ta::::a    a:::::a 
  D:::::::::::::::DD    e::::::::eeeeeeee  x:::::x  x:::::x        tt::::::::::::::t e::::::::eeeeeeee   r:::::r                 B:::::::::::::::::B i::::::i g::::::::::::::::g  u:::::::::::::::u e::::::::eeeeeeee        tt::::::::::::::ta:::::aaaa::::::a 
  D::::::::::::DDD       ee:::::::::::::e x:::::x    x:::::x         tt:::::::::::tt  ee:::::::::::::e   r:::::r                 B::::::::::::::::B  i::::::i  gg::::::::::::::g   uu::::::::uu:::u  ee:::::::::::::e          tt:::::::::::tt a::::::::::aa:::a
  DDDDDDDDDDDDD            eeeeeeeeeeeeeexxxxxxx      xxxxxxx          ttttttttttt      eeeeeeeeeeeeee   rrrrrrr                 BBBBBBBBBBBBBBBBB   iiiiiiii    gggggggg::::::g     uuuuuuuu  uuuu    eeeeeeeeeeeeee            ttttttttttt    aaaaaaaaaa  aaaa
                                                                                                                                                                        g:::::g                                                                                
                                                                                                                                                            gggggg      g:::::g                                                                                
                                                                                                                                                            g:::::gg   gg:::::g                                                                                
                                                                                                                                                              g::::::ggg:::::::g                                                                                
                                                                                                                                                              gg:::::::::::::g                                                                                 
                                                                                                                                                                ggg::::::ggg                                                                                   
                                                                                                                                                                    gggggg                                                                                      

      The final easter egg is this or if    https://mse-course-navigator.web.app/dexterbigueta
      you're using the sfu domain use this  http://mse-course-nav.mse.surrey.sfu.ca/dexterbigueta

      No button leads to those links, you have to manually type it in
                                                                                                                                                                    
  */}

      <div className="grid-item title">
        <h1>Four-Year MSE Curriculum</h1>
      </div>
      <div className = "grid-item t1 term">
        <p>Semester 1 - Fall</p>
      </div>

      <div className="courses t1">
        <div className = "grid-item">
          <Link to="/MSE100" className="dark-orange">MSE 100</Link>
        </div>
        <div className = "grid-item">
          <Link to="/CHEM120" className="orange">CHEM 120</Link>
        </div>
        <div className = "grid-item">
          <Link to="/CMPT130" className="orange">CMPT 130</Link>
        </div>
        <div className = "grid-item">
          <Link to="/PHYS140" className="orange">PHYS 140</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MATH151" className="orange">MATH 151</Link>
        </div>
        <div className = "grid-item">
          <Link to="/CE" className="orange">CE-1</Link>
        </div>
      </div>
      
      <div className = "grid-item t2 term">
        <p>Semester 2 - Spring</p>
      </div>

      <div className="courses t2">
        <div className = "grid-item">
          <Link to="/MSE101W" className="purple">MSE 101W</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MSE102" className="purple">MSE 102</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MSE110" className="gold">MSE 110</Link>
        </div>
        <div className = "grid-item">
          <Link to="/PHYS141" className="orange">PHYS 141</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MATH152" className="orange">MATH 152</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MATH232" className="orange">MATH 232</Link>
        </div>
      </div>

      <div className = "grid-item t3 term">
        <p>Semester 3 - Summer</p>
      </div>

      <div className="courses coop-column t3">
        <a className="grid-item gold coop" href = {MSE193()} target = "_blank" rel="noopener noreferrer">MSE 193 (Optional)</a>
      </div>

      <div className = "grid-item t4 term">
        <p>Semester 4 - Fall</p>
      </div>

      <div className="courses t4">
        <div className = "grid-item">
          <Link to="/MSE220" className="dark-orange">MSE 220</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MSE221" className="dark-orange">MSE 221</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MSE250" className="green">MSE 250</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MATH251" className="orange">MATH 251</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MATH260" className="orange">MATH 260</Link>
        </div>
        <div className = "grid-item">
          <Link to="/CE" className="orange">CE-2</Link>
        </div>
      </div>
      
      <div className = "grid-item t5 term">
        <p>Semester 5 - Spring</p>
      </div>

      <div className="courses t5">
        <div className = "grid-item">
          <Link to="/MSE210" className="blue">MSE 210</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MSE211" className="blue">MSE 211</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MSE222" className="dark-orange">MSE 222</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MSE223" className="dark-orange">MSE 223</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MSE251" className="green">MSE 251</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MSE280" className="blue">MSE 280</Link>
        </div>
      </div>

      <div className = "grid-item t6 term">
        <p>Semester 6 - Summer</p>
      </div>

      <div className="courses coop-column t6">
        <a className="grid-item gold coop" href = {MSE293()} target = "_blank" rel="noopener noreferrer">MSE 293 or MSE 294</a>
      </div>

      <div className = "grid-item t7 term">
        <p>Semester 7 - Fall</p>
      </div>

      <div className="courses t7">
        <div className = "grid-item">
          <Link to="/MSE310" className="gold">MSE 310</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MSE320" className="dark-orange">MSE 320</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MSE321" className="dark-orange">MSE 321</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MSE352" className="green">MSE 352</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MSE380" className="blue">MSE 380</Link>
        </div>
      </div>

      <div className = "grid-item t8 term">
        <p>Semester 8 - Spring</p>
      </div>

      <div className="courses coop-column t8">
        <a className="grid-item gold coop" href = {MSE393()} target = "_blank" rel="noopener noreferrer">MSE 393 or MSE 394</a>
      </div>

      <div className = "grid-item t9 term">
        <p>Semester 9 - Summer</p>
      </div>

      <div className="courses t9">
        <div className = "grid-item">
          <Link to="/MSE300" className="purple">MSE 300</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MSE311" className="gold">MSE 311</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MSE312" className="gold">MSE 312</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MSE353" className="green">MSE 353</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MSE381" className="blue">MSE 381</Link>
        </div>
        <div className = "grid-item">
          <Link to="/Test" className="blue">Test</Link>
        </div>
      </div>

      <div className = "grid-item t10 term">
        <p>Semester 10 - Fall</p>
      </div>
      
      <div className="courses coop-column t10">
        <a className="grid-item gold coop" href = {MSE493()} target = "_blank" rel="noopener noreferrer">MSE 493 or MSE 494</a>
      </div>

      <div className = "grid-item t11 term">
        <p>Semester 11 - Spring</p>
      </div>

      <div className="courses t11">
        <div className = "grid-item">
          <Link to="/MSE402" className="purple">MSE 402</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MSE410" className="gold">MSE 410</Link>
        </div>
        <div className = "grid-item">
          <Link to="/ENGELEC" className="grey">ENG. I</Link>
        </div>
        <div className = "grid-item">
          <Link to="/ENGELEC" className="grey">ENG. II</Link>
        </div>
        <div className = "grid-item">
          <Link to="/ENGELEC" className="grey">ENG. III</Link>
        </div>
      </div>
    
      <div className = "grid-item t12 term">
        <p>Semester 12 - Summer</p>
      </div>

      <div className="courses t12">
        <div className = "grid-item">
          <Link to="/MSE405W" className="purple">MSE 405W</Link>
        </div>
        <div className = "grid-item">
          <Link to="/MSE411" className="gold">MSE 411</Link>
        </div>
        <div className = "grid-item">
          <Link to="/ENGELEC" className="grey">ENG. IV</Link>
        </div>
        <div className = "grid-item">
          <Link to="/ENGELEC" className="grey">ENG. V</Link>
        </div>
        <div className = "grid-item">
          <Link to="/ENGELEC" className="grey">ENG. VI</Link>
        </div>
        <div className = "grid-item">
          <Link to="/CE" className="orange">CE-3</Link>
        </div>
      </div>

      <div className="t13">
        <div className="legend-items">
          <p className="legend-mechanical">B</p>
          <p>Mechanical Engineering</p>
        </div>
        
        <div className="legend-items">
          <p className="legend-electrical">I</p>
          <p>Electrical Engineering</p>
        </div>

        <div className="legend-items">
          <p className="legend-math">G</p>
          <p>Systems Engineering</p>
        </div>

        <div className="legend-items">
          <p className="legend-mechatronics">U</p>
          <p>Mechatronic Engineering</p>
        </div>

        <div className="legend-items">
          <p className="legend-elective">E</p>
          <p>Engineering Electives</p>
        </div>

        <div className="legend-items">
          <p className="legend-comp">T</p>
          <p>Complementary Courses</p>
        </div>

        <div className="legend-items">
          <p className="legend-service">A</p>
          <p>Service Courses</p>
        </div>
        
      </div>

    </div>
  );
}

export default Home;
